import React from 'react';

import { IOlympicList, olympicConst } from 'modules/online-olympic';

import PendingDtm from './dtm';
import FixedSubject from './fixed-subject';
import FixedSubjects from './fixed-subjects';

interface IProps {
  olympic?: IOlympicList;
  type: olympicConst.OlympicTypes;
}

const OlympicPending: React.FC<IProps> = ({ type, olympic }) => {
  const componentMap: Record<string, JSX.Element> = {
    [olympicConst.OlympicTypes.DTM]: <PendingDtm olympic={olympic} />,
    [olympicConst.OlympicTypes.FIXED_SUBJECTS]: (
      <FixedSubjects status={olympic?.status} turnerName={olympic?.name} startedTime={olympic?.started_time} />
    ),
    [olympicConst.OlympicTypes.FIXED_SUBJECT]: (
      <FixedSubject
        status={olympic?.status}
        requiredSubjects={olympic?.required_subjects}
        startedTime={olympic?.started_time}
      />
    )
  };

  return componentMap[type] || null;
};

export default OlympicPending;
